<template>
  <div>
    <el-card>
      <div slot="header">
        <span>标题</span>
      </div>

      <div class="col">

        <el-button type="success" @click='edit("")' size="small" style="width: 80px;">新增</el-button>

        <search :formList="searchList" @search='search'>

          <template v-slot="scope">
            <category style="margin-right: 10px;" :category_id.sync="scope.form[1].value"></category>
          </template>

        </search>

        <el-table :data="list.data" style="width: 100%" v-loading='loading' stripe>
          <el-table-column prop="id" label="ID">
          </el-table-column>

          <el-table-column prop="title" label="商品名称">
          </el-table-column>


          <el-table-column  label="分类">


            <template v-slot="item">
              {{item.row.category_with_pname}}
            </template>

          </el-table-column>



          <el-table-column label="操作">

            <template v-slot="scope">
              <el-button type="primary" size="mini" @click='edit(scope.row)'>编辑</el-button>
              <el-button type="danger" size="mini" @click='destroy(scope.row.id)'>删除</el-button>
            </template>

          </el-table-column>

        </el-table>

        <el-divider></el-divider>

        <el-pagination layout="prev,pager,next" :current-page='this.$route.query.p | page' :total="list.total"
          @current-change='next' background>
        </el-pagination>

      </div>



    </el-card>
  </div>
</template>

<script>
  import Search from '../common/Search.vue'

  import Category from "../common/Category";

  export default {
    name: "GoodsList",
    data() {
      return {
        loading: false,
        list: {},
        searchList: [
          {
            type: 'input',
            title: '商品名称',
            value: '',
            field: 'title',
            condition: 'like'
          },
          {
            type: '',
            title: '',
            custom: true,
            value: '',
            dec: 'category_id'
          },


        ]

      }
    },
    methods: {

      next(page) {

        this.routerSearch(this, {
          p: page
        });

      },
      edit(row) {

        // console.log(row.id);

        // return;

        this.$router.push({
          path: '/main/goods_edit',
          query: {
            id: row.id
          }
        });
      },
      destroy(id) {

        this.msgBoxAjaxWithMessage('提示', '确定删除吗?', '/admin/goods/delete', {
          id: id
        }).then((re) => {

          this.getList();

        })

      },
      getList() {


        this.httpPost({
          url: "/admin/goods/list",
          data: this.$route.query,
          loading: true
        }).then((re) => {

          this.list = re.data;

        })


      },
      search(value) {

        this.routerSearch(this, {
          search: JSON.stringify(value),
          p: 1
        });

      }



    },
    created() {

      this.getList();

    },
    computed: {

    },
    components: {
      Search,
      Category
    }

  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/goods/GoodsList.vue